import useGetMemberCompany from "#/components/company/hooks/useGetMemberCompany"

// DGA US segment. Step 3 DGA consent only targets US-based DGA members.
const DGA_US_SEGMENT_ID = 2586 as const

export function useIsDgaUsMember(): boolean {
  const memberCompany = useGetMemberCompany()
  return memberCompany?.data?.companyId === DGA_US_SEGMENT_ID
}
